import { BrandingStyle, CCTM, CCTM_item, CCTM_items, CCTM_link, CCTM_nav, CCTM_route, CCTM_subnav, Link, useBCMSModal, useCCTM, useModel, useStateManager } from '@bcm-dev/bcms-vite';
import Util from "classes/Util";
import AccountSelect from "components/custom-ui/AccountSelect";
import { LayoutContainer, LeftColumnContainer, RightColumnContainer } from "components/shared";
import React from "react";
import { SVGAsset } from "res";
import "./mobile.css";
import "./styles.css";

/**
* @function AccountDetailsWidget
* @return {React.Component}
* @param {STRING} accountNumber - The account number
* @exported true
* @description This allows the user to select the account and see a high level overview of the account details.
* @example 
* <AccountDetailsWidget />
*/
export default function AccountDetailsWidget(props) {
  const { data, ui } = useStateManager();

  const account = data.account;
  const accountNumber = account.number ?? "";

  return (
    <div className="account-details-widget">
      <LayoutContainer>
        <LeftColumnContainer>
          <AccountSelect account={account} active={ui.accountSelect.isActive} />
          <p className="sub-text account-number">{accountNumber}</p>
          <AccountBalanceView />
        </LeftColumnContainer>
        <RightColumnContainer>
          <AccountActionsView />
        </RightColumnContainer>
      </LayoutContainer>
    </div>
  );
}

/**
* @function AccountActionWrapper
* @return {React.Component}
*/
export function AccountActionWrapper(props) {


  return (
    <>{props.children}</>
  )
}
/**
* @function AccountDetailsLeftWrapper
* @return {React.Component}
*/
export function AccountDetailsLeftWrapper(props) {


  return (

    <div className="flex-container set-width flex-vertical left-action-column">
      {props.children}
    </div>

  )
}
/**
* @function AccountDetailsRightWrapper
* @return {React.Component}
*/
export function AccountDetailsRightWrapper(props) {


  return (

    <div className="flex-container set-width flex-vertical right-action-column">
      {props.children}
    </div>

  )
}
/**
* @function AccountDetailsLink
* @return {React.Component}
*/
export function AccountDetailsLink(props) {
  let to = props.to;
  const { branding } = useModel();
  const { data } = useStateManager();
  const mabi23Branding = window.mabi23Branding;
  let _branding = { colors: branding.colors, options: branding.options };

  if (mabi23Branding) {
    _branding = mabi23Branding;
  }

  const account = data.account;
  const className = props["custom-class"] ? " " + props["custom-class"] : "";
  const { open } = useBCMSModal();
  let modalID = props.to?.split("modal/");
  let onClick = () => {
  };
  const openMenuModal = evt => {
    const MenuModalID = window.innerWidth <= 625 ? "MenuModal" : "MenuModal";
    const detailModalID = window.innerWidth <= 625 ? "MobileAccountDetailsModal" : "AccountDetailsModal";
    if (modalID && modalID[1] === "accountDetailsModal") {
      open(detailModalID, account);
    } else {
      if (modalID && modalID[1]) {
        open(MenuModalID, modalID[1]);
      }
    }




  }

  if (modalID && modalID[1]) {
    to = "";
    onClick = () => {

      openMenuModal()
    };
  }
  if (props.onClick) {
    to = "";

    onClick = () => {

      props.onClick()
    };
  }

  if (_branding.options.orderchecks_mabi23 === "false" && (props.label.toLowerCase().indexOf("check") !== -1 || props.id.toLowerCase().indexOf("order_checks") !== -1) ) {
    return <></>;
  }
    if (_branding.options.statements_mabi23 === "false" && (props.label.toLowerCase().indexOf("statement") !== -1 || props.id.toLowerCase().indexOf("statement") !== -1) ) {
      return <></>;
    }
    if(props.id.toLowerCase().indexOf("statements_ede") !== -1) {
      to = "";
    onClick = () => {
          if (Util.inMabi) {
            Util.openMabiEDEStatementsInMABI23();
          } else {
            window.open(window.location.href.slice(0, window.location.href.indexOf("#")) + "#/edeStatements", "_blank");
          }
        };
      }

      // Use an asset icon classes if set.
      const customClassForIcon = props["asset_custom-class"] ? { className: props["asset_custom-class"] } : {};

      return (

        <div className={"account-action-link" + className}>

          <div className="flex-container set-width highlighted-text">
            <BrandingStyle style={{ "fill": "links_abi22" }} { ...customClassForIcon } element={<SVGAsset id={props.asset_name} />} />
            <Link className={"account-action-link"} to={to} onClick={onClick}>
              <BrandingStyle style={{ "color": "links_abi22" }} element={<p data-point={props.datapoint}>{props.label}</p>} />
            </Link>
          </div>

        </div>
      )

   
}
/**
* @function AccountActionsView
* @return {React.Component}
* @param {BOOLEAN} isCheckingAccount - If true, this will show the "Order Checks" option, it false, nothing is shown.
* @exported false
* @description This is a variation that shows all the additional action links including the order checks option.
* @example 
* <AccountActionsView />
*/
function AccountActionsView(props) {
  const { branding } = useModel();
  const { options } = branding;
  const { data } = useStateManager();
  const account = data.account;
  const xml = useCCTM();
  const mabi23Branding = window.mabi23Branding;
  let _branding = { colors: branding.colors, options: branding.options };

  if (mabi23Branding) {
    _branding = mabi23Branding;
  }
  const statement = Util.inMabi ? xml.querySelector(`[id="sideNav_accounts_estatements_notices"]`) : xml.querySelector(`[id="mainNav_accounts_statements"]`)
  const statementTo = statement?.attributes?.disabled?.value !== "false" ? statement?.attributes?.to?.value : false;
  const notifiVersion = options.notifi_version_abi22;
  let accountDetailRightID = "accountDetailsRightChecking";
  let accountDetailLeftID = "accountDetailsLeftChecking";
  switch (account.type.toLowerCase()) {
    case "checking":
      accountDetailRightID = "accountDetailsRightChecking";
      accountDetailLeftID = "accountDetailsLeftChecking";
      break;
    case "savings":
      accountDetailRightID = "accountDetailsRightSavings";
      accountDetailLeftID = "accountDetailsLeftSavings";
      break;
    case "cod":
      accountDetailRightID = "accountDetailsRightCOD";
      accountDetailLeftID = "accountDetailsLeftCOD";
      break;
    case "loan":
      accountDetailRightID = "accountDetailsRightLoan";
      accountDetailLeftID = "accountDetailsLeftLoan";
      break;
    default:
      accountDetailRightID = "accountDetailsRightChecking";
      accountDetailLeftID = "accountDetailsLeftChecking";
  }

  const accountRightDtls = <CCTM nav-id={accountDetailRightID} xml={xml} self={AccountActionWrapper}>
    <CCTM_nav component={AccountDetailsRightWrapper} />
    <CCTM_route component={AccountDetailsLink} />
    <CCTM_link component={AccountDetailsLink} />
    <CCTM_item component={AccountDetailsLink} />
    <CCTM_items component={AccountActionWrapper} />
    <CCTM_subnav component={AccountActionWrapper} />
  </CCTM>;
  const accountLeftDtls = <CCTM nav-id={accountDetailLeftID} xml={xml} self={AccountActionWrapper}>
    <CCTM_nav component={AccountDetailsLeftWrapper} />
    <CCTM_route component={AccountDetailsLink} />
    <CCTM_link component={AccountDetailsLink} />
    <CCTM_item component={AccountDetailsLink} />
    <CCTM_items component={AccountActionWrapper} />
    <CCTM_subnav component={AccountActionWrapper} />
  </CCTM>;
  return <div className="account-actions-view flex-container justify-right" data-point="Account_Details_Options">
    {accountLeftDtls}
    {accountRightDtls}

  </div>
  /*
    const isCheckingAccount = account.type !== "checking" ? (<></>) :
      (<DisabledPrompt>
        <Link>
          <div className="flex-container highlighted-text">
            <BrandingStyle style={{ "fill": "links_abi22" }} className="icon inline-text-icon left-icon" element={<SVGAsset id="CardIcon" />} />
            <BrandingStyle style={{ "color": "links_abi22" }} element={<p data-point="Order_Checks">Order Checks</p>} />
  
          </div>
        </Link>
      </DisabledPrompt>);
  
    const detailsLink =
      <Link className="account-action-link">
        <div className="flex-container set-width highlighted-text">
          {options.bid_abi22 === "126" ?
            <><BrandingStyle style={{ "color": "links_abi22" }} element={<p data-point="Account_Details">Account Number and Details</p>} /></>
            : <><BrandingStyle style={{ "fill": "links_abi22" }} className="icon inline-text-icon left-icon" element={<SVGAsset id="WalletIcon" />} />
              <BrandingStyle style={{ "color": "links_abi22" }} element={<p data-point="Account_Details">Details</p>} /> </>}
  
        </div>
      </Link>;
  
    const { open } = useBCMSModal();
    const openDetailsModal = evt => {
      const detailModalID = window.innerWidth <= 625 ? "MobileAccountDetailsModal" : "AccountDetailsModal";
      open(detailModalID, account);
    }
  
    return (
      <div className="account-actions-view flex-container justify-right" data-point="Account_Details_Options">
        <div className="flex-container set-width flex-vertical left-action-column">
        {
        !Util.inMabi ?
          <Branding id="order_checks_abi22" value="true">
            {isCheckingAccount}
          </Branding>:
            _branding.options.orderchecks_mabi23 == "false" ?
              <></>
            :  <Branding id="order_checks_abi22" value="true">
            {isCheckingAccount}
              </Branding>
          }
          {
            (account.type === "checking" || account.type === "savings") &&
            <Branding id="bid_abi22" value="126">
                <Link to="/chw23" className="show-on-desktop">
                  <div className="flex-container highlighted-text">
                    <BrandingStyle style={{ "fill": "links_abi22" }} className="icon inline-text-icon left-icon" element={<SVGAsset id="CardIcon" />} />
                    <BrandingStyle style={{ "color": "links_abi22" }} element={<p>Cards</p>} />
                  </div>
                </Link>
                <Link to="/ch21" className="show-on-mobile">
                  <div className="flex-container highlighted-text">
                    <BrandingStyle style={{ "fill": "links_abi22" }} className="icon inline-text-icon left-icon" element={<SVGAsset id="CardIcon" />} />
                    <BrandingStyle style={{ "color": "links_abi22" }} element={<p>Cards</p>} />
                  </div>
                </Link>
            </Branding>
            } 
  
        </div>
        <div className="flex-container set-width flex-vertical right-action-column">
          <Branding id="details_modal_abi22" value="true">
            {
              (account.type !== "checking" && account.type !== "loc")
                ? <DisabledPrompt className="account-action-link">{detailsLink}</DisabledPrompt>
                : <div className="account-action-link" onClick={openDetailsModal}>{detailsLink}</div>
            }
          </Branding>
          <Branding id="acct_details_alerts_abi22" value="true">
            <BrandingDisabledIf id="notifi_version_abi22" exp={(val) => val !== "Disabled"}>
              <Link className="account-action-link" to={ notifiVersion === "Native Alerts" ? "/alerts" : "/notifications" }>
                <div className="flex-container set-width highlighted-text">
                  <BrandingStyle style={{ "fill": "links_abi22" }} className="icon inline-text-icon left-icon" element={<SVGAsset id="BellIcon" />} />
                  <BrandingStyle style={{ "color": "links_abi22" }} element={<p data-point="Alerts">Alerts</p>} />
                </div>
              </Link>
  
            </BrandingDisabledIf>
          </Branding>
          <Branding id="acctdtls_statements_abi22" value="true">
          {statementTo && (options.bid_abi22 === "126" ?
              <Link className="account-action-link view-statements-link" to={statementTo}>
                <div className="flex-container set-width highlighted-text">
                  <BrandingStyle style={{ "color": "links_abi22" }} element={<p data-point="Statements">View Statements</p>} />
                </div>
              </Link>
              : <Link className="account-action-link" to={statementTo}>
                <div className="flex-container set-width highlighted-text">
                  <BrandingStyle style={{ "fill": "links_abi22" }} className="icon inline-text-icon left-icon" element={<SVGAsset id="CheckListIcon" />} />
                  <BrandingStyle style={{ "color": "links_abi22" }} element={<p data-point="Statements">Statements</p>} />
                </div>
              </Link>)}
              {!statementTo &&  <DisabledPrompt>
                 {options.bid_abi22 === "126" ?
                    <Link className="account-action-link view-statements-link" to={statementTo}>
                      <div className="flex-container set-width highlighted-text">
                        <BrandingStyle style={{ "color": "links_abi22" }} element={<p data-point="Statements">View Statements</p>} />
                      </div>
                    </Link>
                    : <Link className="account-action-link" to={statementTo}>
                      <div className="flex-container set-width highlighted-text">
                        <BrandingStyle style={{ "fill": "links_abi22" }} className="icon inline-text-icon left-icon" element={<SVGAsset id="CheckListIcon" />} />
                        <BrandingStyle style={{ "color": "links_abi22" }} element={<p data-point="Statements">Statements</p>} />
                      </div>
                    </Link>}
              </DisabledPrompt>}
          </Branding>
          {(options.bid_abi22 === "126") &&
            <DisabledPrompt>
              <Link className="account-action-link chat-with-us-link">
                <div className="flex-container set-width highlighted-text">
                  <BrandingStyle style={{ "color": "links_abi22" }} element={<p data-point="Chat">Chat with Us</p>} />
                </div>
              </Link>
            </DisabledPrompt>
          }
        </div>
      </div>
    );*/
}

/**
* @function AccountBalanceView
* @return {React.Component}
* @param {DECIMAL} availableBalance - This is the available balance of the account
* @param {DECIMAL} currentBalance - This is the current balance of the account
* @exported false
* @description AccountBalanceView is a component that shows the available balance and the current balance for the selected account.
* @example 
* <AccountBalanceView availableBalance="$7,231,224.04" currentBalance="$9,987,243.09" />
*/
export function AccountBalanceView(props) {
  const { data } = useStateManager();
  const account = data.account;

  const primaryBalance = (account.type === "loan" || account.type === "loc") ? account.currentBalance : account.availableBalance;
  const secondaryBalance = (account.type === "loan" || account.type === "loc") ? account.availableCredit : account.currentBalance;

  return (
    <div className="account-balance-view flex-container" data-point="Account_Details_Balances">
      <div className="flex-width account-balance-container">
        <p className="account-total"><b data-point="Account_Balance">{primaryBalance.format()}</b></p>
        <p className="sub-text">{account.balanceLabel}</p>
      </div>
      <div className="flex-width account-balance-container">
        <p className="account-total"><b>{secondaryBalance.format()}</b></p>
        <p className="sub-text">{account.secondaryBalanceLabel}</p>
      </div>
    </div>
  );
}